import { createSlice } from '@reduxjs/toolkit';

import type { ProjectId } from 'cadenza/repository/model/project-id.gen';
import { itemIdFromUrlString } from 'cadenza/repository/model/repository-item-id';
import type { RootStateOr } from 'cadenza/store/cadenza-store';
import { createSliceFunction, getStore } from 'cadenza/store/cadenza-store';

export const SLICE_PREFIX = 'cadenza';

declare module 'cadenza/store/cadenza-store' {
  interface RootState {
    [SLICE_PREFIX]: CadenzaState;
  }
}

const slice = createSliceFunction(SLICE_PREFIX);

interface CadenzaState {
  projectId?: ProjectId;
}

const initialState: CadenzaState = {
  projectId: location.pathname.includes('/projects/') ? itemIdFromUrlString('PROJECT') : undefined,
};

export const cadenzaSlice = createSlice({
  name: SLICE_PREFIX,
  initialState: { ...initialState },
  reducers: {
    setProjectId(state, { payload }) {
      state.projectId = payload;
    },
  },
});

const { reducer, actions } = cadenzaSlice;
getStore().registerReducer(SLICE_PREFIX, reducer);

export const { setProjectId } = actions;

export function getProjectId(state: RootStateOr<CadenzaState>): ProjectId | undefined {
  return slice(state).projectId;
}
